<template>
  <v-dialog v-model="display" width="500"
    ><v-card>
      <v-card-title class="headline">
        {{ title }}
      </v-card-title>
      <v-card-text>
        {{ message }}
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="display = false"> ok </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({
    display: false
  }),

  props: {
    error: { type: String, default: null }
  },
  computed: {
    title () {
      return this.$t('error.api-title')
    },
    message () {
      return this.$t('error.api-message')
    }
  },
  watch: {
    error: function (newVal, oldVal) {
      if (newVal) {
        this.display = true
      }
    }
  }
}
</script>

<style>
#message {
  margin-top: 50px;
}
</style>
